import React, { useEffect, useRef } from "react";

import { iniciarPoeira } from "./motorDaPoeira";

/** O <canvas> das partículas; para o loop e os observers ao desmontar. */
export default function Poeira() {
  const ref = useRef(null);
  useEffect(() => iniciarPoeira(ref.current), []);
  return <canvas className="dust-cv" aria-hidden="true" ref={ref} />;
}
